import { useState, useEffect } from 'react';
import { Box, IconButton, styled, Typography } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { NRHero } from '../../constant';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';


const Dot = styled('div')(({ active }) => ({
  width: active ? 32 : 12,
  height: 12,
  borderRadius: active ? 6 : '50%',
  background: active
    ? 'linear-gradient(262.41deg, #1DA1F2 -8.32%, #6843EC 93.3%)'
    : '#fff',
  margin: '0 4px',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
}));


const NewsroomLanding = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [slides, setSlides] = useState(null);

  useEffect(() => {
    getNewSlideList();
  }, []);


  useEffect(() => {
    if (!slides?.length || isHovered) return;
    const interval = setInterval(() => {
      setActiveIndex((prev) =>
        prev === slides.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [slides, isHovered]);

  const getNewSlideList = async (page = 1, limit = 100) => {
    try {
      let url = `https://dev.ienergydigital.com/task-api/api/cms/entries/?type=newsroom_hero&page=${page}&limit=${limit}`;
      const response = await axios.get(url);
      setSlides(response.data?.data?.entries ||[]);
    } catch (error) {
      console.error(error);
    }
  };

  // const handleOpenNewsDetail = () => {
  //   const slug = slides?.[activeIndex]?.slug;

  //   if (!slug) return;

  //   navigate(`/newsroom-details/${slug}`, {
  //     state: {
  //       slug
  //     },
  //   });
  // };

  return (
    <Box
      sx={{
        position: 'relative',
        height: 400,
        overflow: 'hidden',
        minHeight: { xs: "80vh", md: "80vh" },
        padding: { xs: "60px 24px", md: "60px 80px", lg: "60px 150px" },
        margin: "auto",
        maxWidth: "100%",
        cursor: "pointer",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      //onClick={handleOpenNewsDetail}

    >

      <AnimatePresence initial={false}>
        <motion.div
          key={activeIndex}
          initial={{ x: 300, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: -300, opacity: 0 }}
          transition={{ duration: 0.5 }}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: -1,
            overflow: "hidden",
          }}
        >
          <img
            src={NRHero}
            //src={slides?.[activeIndex]?.contentJson?.image}
            alt="Background"
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
          <Box
            component={motion.div}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            sx={{
              position: 'relative',
              height: '80%',
              color: 'black',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              backgroundColor: 'transparent',
              whiteSpace: 'pre-line',
              width: '80%',
              margin: '0 auto',
              zIndex: 3,
            }}
          >
            <Typography sx={{ fontSize: '16px', color: '#8C8CC2' }}>
              {slides?.[activeIndex]?.contentJson?.shortDesc}
            </Typography>
            <Typography sx={{ fontSize: '32px', color: '#fff', fontWeight: 700, mt: 1 }}>
              {slides?.[activeIndex]?.contentJson?.heading1}
            </Typography>
            <Typography sx={{ fontSize: '32px', color: '#fff', fontWeight: 700, mt: 1 }}>
              {slides?.[activeIndex]?.contentJson?.heading2}
            </Typography>
            <Typography sx={{ fontSize: '18px', color: '#fff', fontWeight: 300, mt: 3 }}>
              {slides?.[activeIndex]?.contentJson?.description}
            </Typography>
          </Box>
        </motion.div>
      </AnimatePresence>

      {/* Dots Navigation */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 16,
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          zIndex: 1,
        }}
      >
        {slides?.map((_, index) => (
          <IconButton
            key={index}
            onClick={(e) => {
              e.stopPropagation();
              setActiveIndex(index);
            }}
            size="small"
            sx={{ p: 0 }}
          >
            <Dot active={index === activeIndex} />
          </IconButton>
        ))}
      </Box>
    </Box>
  );
};

export default NewsroomLanding;